import React from 'react'; // No necesitamos useEffect/useRef
// import gsap from 'gsap'; // No más GSAP
// import { ScrollTrigger } from 'gsap/ScrollTrigger'; // No más GSAP

import './LandingPage.css';
import LHeader from '../components/landing/LHeader';
import LHero from '../components/landing/LHero';
import LSpacyHub from '../components/landing/LSpacyHub';
import LHybridAcademy from '../components/landing/LHybridAcademy';
import LPricing from '../components/landing/LPricing';
import LTestimonials from '../components/landing/LTestimonials';
import LFinalCTA from '../components/landing/LFinalCTA';
import LFooter from '../components/landing/LFooter';

// Todo el registro de plugins ha sido eliminado

function LandingPage() {
  // Todo el useEffect de partículas y parallax ha sido eliminado

  return (
    // Ya no necesitamos la ref
    <div className="landing-page-wrapper">
      {/* <div className="particles"></div> */} {/* Contenedor de partículas eliminado */}
      <LHeader />
      <main>
        <LHero />
        <LSpacyHub />
        <LHybridAcademy />
        <LPricing />
        <LTestimonials />
        <LFinalCTA />
      </main>
      <LFooter />
    </div>
  );
}

export default LandingPage;